import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import { components } from '@glowforge/ui-common';

import './legal-page.less';

const { Markdown } = components;

const LegalPage = (props) => {
  const title = props.title ? <h1 className='h1'>{props.title}</h1> : null;

  return (
    <div className='LegalPage contentPage'>
      <Helmet title={props.title} />
      <div className='content'>
        {title}
        <Markdown
          className='termsMarkdown paragraph'
          source={
            `${props.legalContent} ${props.legalContentPart2}`
          } />
      </div>
    </div>
  );
};

LegalPage.propTypes = {
  title: PropTypes.string,
  legalContent: PropTypes.string.isRequired,
  legalContentPart2: PropTypes.string,
};

LegalPage.defaultProps = {
  title: null,
  legalContentPart2: '',
};

export default LegalPage;



// WEBPACK FOOTER //
// ./app/components/legal/legal-page.jsx